import React, { FC } from 'react';

import ProductCover from '../../common/ProductCover';
import { PreviewButton } from '../../preview/PreviewButton';
import { ProductMetaData } from '../../../../models/Product';

type Props = {
    readonly product: ProductMetaData;
};

const ProductDetailCover: FC<Props> = props => (
    <div className="pd-image">
        <ProductCover minSizeInPx={760} product={props.product} />
        <PreviewButton product={props.product} />
    </div>
);

export default ProductDetailCover;
